<template>
  <div class="row">
    <!-- Map -->
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <h3 class="card-title">
            <div id="map" class="map" style="height: 473px">
              <l-map
                ref="map"
                :zoom="zoom"
                :center="center"
                :bounds="bounds"
                class="sidebar-map"
              >
                <l-tile-layer
                  :url="url"
                  :attribution="attribution"
                ></l-tile-layer>
                <l-control
                  style="
                    border: 1px #000000 solid;
                    background-color: #ffffff;
                    color: #000000;
                  "
                  position="topright"
                >
                  <div id="legend">
                    <!-- <b style="font-size: 12px">Legend</b> -->
                    <div class="legend_attr">
                      <img
                        src="@/assets/img/Good RSSI Icon 2.png"
                        style="width: 40px"
                      />
                      Good RSSI (120db)
                    </div>
                    <div class="legend_attr">
                      <img
                        src="@/assets/img/Weak Signal Icon 2.png"
                        style="width: 40px"
                      />
                      Weak RSSI (>120db)
                    </div>
                    <div class="legend_attr">
                      <img
                        src="@/assets/img/Disconnected Icon 2.png"
                        style="width: 40px"
                      />
                      Disconnected
                    </div>
                    <div class="legend_attr">
                      <img
                        src="@/assets/img/Connected Gateway.png"
                        style="width: 40px"
                      />
                      Connected Gateway
                    </div>
                    <div class="legend_attr">
                      <img
                        src="@/assets/img/totalgateway2.png"
                        style="width: 40px"
                      />
                      Disconnected Gateway
                    </div>
                  </div>
                </l-control>
                <!-- <l-control v-if="view" style="margin: auto; border: 1px #000000 solid; background-color: #ffffff; color: #000000;" position="bottomleft">
                  <div id="legend">
                    <div class="legend_attr">
                      <img src="@/assets/img/Good RSSI Icon 2.png" style="width: 40px" />
                      Contoh
                    </div>
                  </div>
                </l-control> -->
                <l-marker
                  v-for="marker in markers"
                  :lat-lng="marker.location"
                  :key="marker.addMarker"
                  :icon="markericon(marker.marker)"
                >
                  <l-popup>
                    <div class="row">
                      <div class="col-lg-12">
                        <b><u>RSSI value</u></b>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        Gateway to device:
                        <img
                          src="@/assets/img/signal1.png"
                          style="width: 40px"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        Device to device:
                        <img
                          src="@/assets/img/signal3.png"
                          style="width: 40px"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">Packet loss: 0</div>
                    </div>
                  </l-popup>
                </l-marker>
              </l-map>
            </div>
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg d-flex">
          <card
            card-body-classes="table-full-width"
            style="text-align: center; height: 420px"
          >
            <br /><br /><br />
            <img
              src="@/assets/img/Disconnected Gateway Icon.png"
              alt="preview"
              width="120px"
            />

            <h4>TOTAL <br />GATEWAY</h4>
            <h1 style="font-size: 50px; padding: 50px 0; text-align: center">
              3
            </h1>
          </card>
        </div>
        <div class="col-lg d-flex">
          <card
            card-body-classes="table-full-width"
            style="text-align: center; height: 420px"
          >
            <br /><br /><br />
            <img
              src="@/assets/img/Connected Gateway.png"
              alt="preview"
              width="120px"
            />

            <h4>CONNECTED <br />GATEWAY</h4>
            <h1 style="font-size: 50px; padding: 50px 0; text-align: center">
              2
            </h1>
          </card>
        </div>
        <div class="col-lg d-flex">
          <card
            card-body-classes="table-full-width"
            style="text-align: center; height: 420px"
          >
            <br /><br /><br />
            <img
              src="@/assets/img/totalgateway2.png"
              alt="preview"
              width="120px"
            />

            <h4>DISCONNECTED <br />GATEWAY</h4>
            <h1 style="font-size: 50px; padding: 50px 0; text-align: center">
              1
            </h1>
          </card>
        </div>
        <div class="col-lg-7 d-flex" style="">
          <card class="chart-card" style="text-align: left; height: 420px">
            <h4>GATEWAY STATUS</h4>
            <el-table
              :data="gateway"
              :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
            >
              <el-table-column prop="id" label="ID" min-width="100px">
                <div slot-scope="{ row }">
                  {{ row.id }}
                  <i
                    class="fa fa-info-circle text-info"
                    type="info"
                    aria-hidden="true"
                  ></i>
                </div>
              </el-table-column>
              <el-table-column min-width="140px" prop="status" label="Status">
              </el-table-column>
              <el-table-column
                min-width="110px"
                prop="connecteddevice"
                label="Connected device"
              >
              </el-table-column>
              <el-table-column prop="sf" label="SF"> </el-table-column>
              <el-table-column
                min-width="90px"
                prop="bitrate"
                label="Bitrate(bit/s)"
              >
              </el-table-column>
              <el-table-column
                min-width="90px"
                prop="airtime"
                label="Airtime(ms)"
              >
              </el-table-column>
              <el-table-column
                min-width="170px"
                prop="packetstatus"
                label="Packet Forwarder Status"
              >
              </el-table-column>
              <el-table-column
                min-width="120px"
                prop="lastseen"
                label="Last Seen"
              >
              </el-table-column>
              <el-table-column
                min-width="150px"
                prop="pinggateway"
                label="Ping Gateway"
              >
                <div slot-scope="{ row }">
                  <input
                    type="image"
                    :src="row.pinggateway"
                    width="40%"
                    height="40%"
                  />
                </div>
              </el-table-column>
            </el-table>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LineChart from "@/components/Charts/LineChart";
import StatsCard from "src/components/Cards/StatsCard";
import swal from "sweetalert2";
import config from "@/config";
import moment from "moment";
import { DoubleBounce } from "vue-loading-spinner";
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LTooltip,
  LControl,
} from "vue2-leaflet";
import { TabPane, Tabs, BaseButton, Modal } from "src/components";
import {
  Table,
  TableColumn,
  Drawer,
  Collapse,
  CollapseItem,
  Select,
  Option,
} from "element-ui";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import Holiday from "../ClusterScheduler/holiday.vue";

export default {
  components: {
    Modal,
    Loading,
    DoubleBounce,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Drawer.name]: Drawer,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Select.name]: Select,
    [Option.name]: Option,
    LineChart,
    StatsCard,
    BaseButton,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip,
    LControl,
    TabPane,
    Holiday,
  },
  data() {
    return {
      // Map
      view: false,
      zoom: 10,
      bounds: [
        [2.920715, 101.63724],
        [2.921171, 101.635727],
        [2.920807, 101.635448],
        [2.918792, 101.636703],
        [2.919205, 101.637497],
      ],
      center: L.latLng(2.920715, 101.63724),
      url: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [
        {
          location: L.latLng(2.920715, 101.63724),
          pointName: "VFH123",
          marker: "Weak RSSI",
        },
        {
          location: L.latLng(2.921171, 101.635727),
          pointName: "VFH123",
          marker: "Good RSSI",
        },
        {
          location: L.latLng(2.919901, 101.636703),
          pointName: "VFH123",
          marker: "Good RSSI",
        },

        {
          location: L.latLng(2.920807, 101.635448),
          pointName: "VFH123",
          marker: "Disconnected",
        },
        {
          location: L.latLng(2.918792, 101.636703),
          pointName: "VFH123",
          marker: "Disconnected Gateway",
        },
        {
          location: L.latLng(2.919205, 101.637497),
          pointName: "VFH123",
          marker: "Connected Gateway",
        },
      ],
      markericon(marker) {
        if (marker == "Weak RSSI") {
          return L.icon({
            iconUrl: require("@/assets/img/Weak Signal Icon 2.png"),
            iconSize: [30, 30], // size of the icon
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            shadowAnchor: [30, 30], // the same for the shadow
            shadowSize: [30, 30],
            popupAnchor: [1, -10],
          });
        } else if (marker == "Disconnected") {
          return L.icon({
            iconUrl: require("@/assets/img/Disconnected Icon 2.png"),
            iconSize: [30, 30], // size of the icon
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            shadowAnchor: [30, 30], // the same for the shadow
            shadowSize: [30, 30],
            popupAnchor: [1, -10],
          });
        } else if (marker == "Connected Gateway") {
          return L.icon({
            iconUrl: require("@/assets/img/Connected Gateway.png"),
            iconSize: [40, 30], // size of the icon
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            shadowAnchor: [30, 30], // the same for the shadow
            shadowSize: [30, 30],
            popupAnchor: [1, -10],
          });
        } else if (marker == "Disconnected Gateway") {
          return L.icon({
            iconUrl: require("@/assets/img/totalgateway2.png"),
            iconSize: [40, 30], // size of the icon
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            shadowAnchor: [30, 30], // the same for the shadow
            shadowSize: [30, 30],
            popupAnchor: [1, -10],
          });
        } else {
          return L.icon({
            iconUrl: require("@/assets/img/Good RSSI Icon 2.png"),
            iconSize: [30, 30], // size of the icon
            iconAnchor: [30, 30], // point of the icon which will correspond to marker's location
            shadowAnchor: [30, 30], // the same for the shadow
            shadowSize: [30, 30],
            popupAnchor: [1, -10],
          });
        }
      },
      gateway: [
        {
          id: "GW 01",
          status: "Connected",
          connecteddevice: "120/125",
          sf: "10",
          bitrate: "980",
          airtime: "370",
          packetstatus: "Active",
          lastseen: "30 sec ago",
          pinggateway: require("@/assets/img/Gateway Ping Icon.png"),
        },
        {
          id: "GW 02",
          status: "Connected",
          connecteddevice: "150/150",
          sf: "10",
          bitrate: "980",
          airtime: "370",
          packetstatus: "Active",
          lastseen: "30 sec ago",
          pinggateway: require("@/assets/img/Gateway Ping Icon.png"),
        },
        {
          id: "GW 03",
          status: "Disconnected",
          connecteddevice: "0/100",
          sf: "10",
          bitrate: "0",
          airtime: "0",
          packetstatus: "Down",
          lastseen: "1 min ago",
          pinggateway: require("@/assets/img/Gateway Ping Icon.png"),
        },
      ],
    };
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.legend_attr {
  padding: 5px;
}
</style>
